import React from 'react';
import { Text } from '@perch-labs/shrike';
import {
  isBefore,
  today,
  formatDate,
  formatWithCommas,
} from '@perch-labs/warbler';
import { Container } from 'styles';
import { getSolarProjectName } from 'utils/format';
import { copyFor } from 'config';

const getCopy = copyFor('solar.stateStats');

export const MarkerPopup = (props: MapMarker) => {
  const { name, totalCapacity, startDate } = props;
  const date = formatDate(startDate, { format: 'MM/dd/yy' });
  return (
    <Container small={{ margin: { top: '8px' } }}>
      <Text
        className="notranslate"
        textStyle="heading400"
        margin="4px 12px 4px 0"
      >
        {getSolarProjectName(name)}
      </Text>
      <Text className="notranslate" textStyle="paragraph400">
        {`${formatWithCommas(Math.round(totalCapacity))} kW`}
      </Text>
      <Text textStyle="paragraph400">
        {isBefore(startDate, today())
          ? getCopy('statsMap.projectStarted', { date })
          : getCopy('statsMap.projectPending', { date })}
      </Text>
    </Container>
  );
};
